var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnThumbsup18 = function SvgLightIcnThumbsup18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z",
    opacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.472 7.475h1.234a.5.5 0 0 1 .5.5v5.775a.5.5 0 0 1-.5.5H3.472A.46.46 0 0 1 3 13.8V7.925c0-.249.212-.45.472-.45M14.398 12.981c-.11.845-.674 1.268-1.677 1.268H7.473c-.713 0-1.292-.545-1.292-1.216V8.39c0-.515.396-.927.894-1.058 1.068-.281 1.602-.903 1.602-2.155V4.43c0-.79.672-1.429 1.5-1.429.316 0 .624.095.88.271.352.243.577.704.577 1.368v2.167c0 .184.312.336.624.336h1.674c.705 0 1.277.53 1.293 1.19.01.44-.266 1.803-.827 4.65",
    clipRule: "evenodd"
  })));
};
export default SvgLightIcnThumbsup18;